/**
 * @module app.hl7
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { HealthLevel7ManagementModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(HealthLevel7ManagementModule.registrationKey, HealthLevel7ManagementModule);

    config.globalResources([
        // elements

        // elements/members

        // elements/providers

        // value-converters
    ]);
}
